import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  input: {
    color: "$input_placeholder",
  },
  text: {
    margin: 10,
    backgroundColor: "$input_background",
    width: "36vmin",
    padding: "1vmax",
    fontSize: "$input_text_size",
    fontFamily: "$input_text_style",
    color: "$input_text",
  },
  "@media (max-width: 700)": {
    text: {
      width: "52vmin",
    },
  },
});
